import 'bootstrap/dist/css/bootstrap.min.css';
import Whatsapp from './pages/Whatsapp'

const App =()=> {
  return <Whatsapp/>;
}

export default App;
